module.exports = __webpack_public_path__ + "static/img/img-rkzxqy-gyqh-bg.87e238a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img-rkzxqy-gyqh-bg.png
// module id = UU+u
// module chunks = 1